export default {
      id: "check-usage",
      viewBox: "0 0 15 15",
      url: "/img/icons/" + "icons-sprite.1792b118.svg#check",
      toString: function () {
        return this.url;
      }
    }